import script from "./MChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MChat.vue?vue&type=script&setup=true&lang=js"

import "./MChat.vue?vue&type=style&index=0&id=2fe057b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe057b0"]])

export default __exports__